<template>
  <v-container fluid>
    <v-layout xs12 align-start row wrap>
      <v-flex xs12 sm12 md12 justify-center>
        <h2 class="ml-2 mb-2">{{ title }}</h2>
        <v-data-table
          :headers="headers"
          :items="items"
          :item-key="title"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:[`item.dt_delivered`]="{ item }">
            {{ formatDate(item.dt_delivered) }}
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ total(item) }}
          </template>
          <template v-slot:[`item.cash`]="{ item }">
            {{ item.change.toFixed(2) }}
          </template>
          <template v-slot:[`item.change`]="{ item }">
            {{ troco(item) }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div @click="editOrder(item)" style="cursor: pointer;">
              <v-icon small class="mr-1">remove_red_eye</v-icon>
            </div>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogOrder" max-width="700px">
          <CartList
            v-bind:cart="editedItem.carts"
            v-bind:order="editedItem"
            @update="close"
          ></CartList>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { UpdateOrdersStatus } from "../../graphql/orders.graphql";
import * as moment from "moment";
//Components
import CartList from "../carts/List.vue";

// let date = new Date();
export default {
  props: {
    title: {
      type: String,
      default: "Pedidos"
    },
    orders: {
      type: Array,
      default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CartList
  },
  name: "OrdersListTable",
  data: () => ({
    dialog: false,
    dialogOrder: false,
    editedItem: [],
    created_at: null,
    items: [],
    headers: [
      { text: "Farmácia", value: "drugstore.name" },
      { text: "Usuario", value: "user.name" },
      { text: "Telefone", value: "user.phones[0].phone" },
      //{ text: "CEP", value: "address.cep" },
      { text: "Logradouro", value: "address.street" },
      { text: "Número", value: "address.number" },
      { text: "Complemento", value: "address.complemento" },
      { text: "Data do pedido", value: "created_at" },
      { text: "Tipo de pagamento", value: "payment_type.type" },
      { text: "Total", value: "total" },
      { text: "Valor em dinheiro", value: "cash" },
      { text: "Troco", value: "change" },
      { text: "Ações", value: "action", sortable: false }
    ]
  }),
  methods: {
    close() {
      this.dialogOrder = false;
    },

    editOrder(item) {
      this.dialogOrder = true;
      this.editedItem = item;
      if (item.id_status === 1) {
        this.$apollo
          .mutate({
            mutation: UpdateOrdersStatus,
            variables: {
              id: item.id,
              status: 2
            }
          })
          .then(data => data);
      }
    },

    total(item) {
      if (!item) return 0;

      var total = 0;
      item.carts.forEach(element => {
        total += element.total;
      });

      return total.toFixed(2);
    },

    troco(item) {
      if (!item) return 0;

      var troco = 0;
      var total = 0;
      item.carts.forEach(element => {
        total += element.total;
      });

      troco = item.change > 0 && total > 0 ? item.change - total : 0;

      return troco.toFixed(2);
    },

    toArray(array) {
      let items = [];
      array.forEach(v => items.push(v));
      return items;
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YY HH:mm");
    }
  },
  watch: {
    orders() {
      this.items = this.orders;
    }
  }
};
</script>
